import type { ReactNode } from 'react';

import { useTheme } from '@emotion/react';

import type { ListVariant } from '../list.context';
import { ListProvider } from '../list.context';

import * as styles from './base-list.styles';

type Props = {
  component: 'ul' | 'ol';
  variant: ListVariant;
  children: ReactNode;
  className?: string;
};

export const BaseList = ({ component, variant, children, className, ...rest }: Props) => {
  const theme = useTheme();
  const Component = component;

  return (
    <Component
      className={className}
      css={[styles.root, styles.variant[variant](theme)]}
      data-testid="base-list"
      {...rest}>
      <ListProvider variant={variant}>{children}</ListProvider>
    </Component>
  );
};
